import { WidgetProps } from '@rjsf/core';
import * as React from 'react';
import { UnderlinedInput } from './UnderlinedInput';

export function OtherField(props: WidgetProps) {
  const placeholderIntlId = props.uiSchema?.['ui:placeholder'] ?? 'pressureTest.ovrigt.placeholder';

  return (
    <UnderlinedInput
      {...props}
      sx={{
        mt: -24,
      }}
      placeholderIntlId={placeholderIntlId}
    />
  );
}
